import {
  ComboboxData,
  GridCol,
  Grid,
  Text,
  MantineSize,
  Box,
  Group,
  SelectProps,
} from "@mantine/core"

import { Select } from "../Select/Select"

type Props = {
  options: ComboboxData
  value: string | null
  onChange: (value: string | null) => void
  label?: string
  labelSpan?: number
  size?: MantineSize
  cta?: React.ReactNode
  selectProps?: SelectProps
}

export function InlineSelectInput({
  options,
  value,
  onChange,
  label,
  labelSpan = 3,
  size = "xs",
  cta,
  selectProps,
}: Props) {
  return (
    <Grid px="var(--mantine-spacing-xs)" w="100%">
      {label && (
        <GridCol
          span={labelSpan}
          style={{ display: "flex", alignItems: "center" }}
        >
          <Text fw={600} fz={size}>
            {label}
          </Text>
        </GridCol>
      )}
      <GridCol span="auto">
        <Group wrap="nowrap" gap="var(--mantine-spacing-xs)">
          <Select
            value={value}
            data={options}
            size={size}
            onChange={onChange}
            w="100%"
            {...selectProps}
          />
          <Box ml="xs">{cta}</Box>
        </Group>
      </GridCol>
    </Grid>
  )
}
